import React, { Component } from 'react';
import SideBar from '../Sidebar/SideBar';
import BackButton from './BackButton';
import './header.less';
import AppContext from 'components/appContext';
import MedSISLogo from 'assets/images/medsis-ce-logo.png';
import {i18nInit} from 'root/internationalization/config';
import config from 'root/../config';

class Header extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={`header-container ${this.context.hideHeader ? "inactive" : ""} ${this.props.elevation ? 'shadow-depth-1' : ''}`}>
                {config.specifics.warningline && 
                    (
                    <div className="warningLineContainer header-margin-15">
                        {config.specifics.warningline}
                    </div>
                    )
                }
                <header className={`header text-center pb-1 pt-2`}>
                    <BackButton {...this.props}/>
                    {this.context.currentScene != null 
                    && this.context.currentScene != "STUDENT_PORTAL" 
                    && this.context.appMap != null 
                    && this.context.appMap[this.context.currentModule][this.context.currentScene] ?
                        <div className="header__logo-page-text">
                            {i18nInit.t(this.context.appMap[this.context.currentModule][this.context.currentScene].name,
                                this.context.appMap[this.context.currentModule][this.context.currentScene].fallbackName)}
                        </div>
                        :
                        <div className="header__logo-container">
                            <img alt="medsis" src={MedSISLogo} className="header__logo" />
                        </div>
                    }

                    <SideBar {...this.props}/>
                </header>
            </div>
          
        )
    }
}

Header.defaultProps = {
    elevation: true,
}
export default Header;